// extracted by mini-css-extract-plugin
export const rows = "FeaturedContentRows-module--rows--3bZaV";